import React from 'react';

const CompanyItem = ({ company, onEdit, onDelete }) => {
  return (
    <div style={styles.item}>
      <div style={styles.name}>{company.name}</div>
      <div style={styles.email}>{company.email}</div>
      <div style={styles.phone}>{company.phone}</div>
      <div style={styles.industry}>{company.industry}</div>
      <div style={styles.location}>{company.location || company.address || 'N/A'}</div>
      <div style={styles.actions}>
        <button
          onClick={onEdit}
          style={styles.editButton}
          title="Edit"
        >
          ✏️
        </button>
        <button
          onClick={onDelete}
          style={styles.deleteButton}
          title="Delete"
          data-company-id={company.id}
        >
          🗑️
        </button>
      </div>
    </div>
  );
};

const styles = {
  item: {
    display: 'grid',
    gridTemplateColumns: '2fr 2fr 1fr 1fr 1fr 1fr',
    gap: '1rem',
    padding: '0.75rem 1rem',
    borderBottom: '1px solid #eee',
    alignItems: 'center',
  },
  name: {
    fontWeight: 'bold',
  },
  email: {},
  phone: {},
  industry: {},
  location: {},
  actions: {
    display: 'flex',
    justifyContent: 'center',
    gap: '0.5rem',
  },
  editButton: {
    padding: '0.25rem 0.5rem',
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '1rem',
  },
  deleteButton: {
    padding: '0.25rem 0.5rem',
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '1rem',
  },
};

export default CompanyItem;
